module.exports = __webpack_public_path__ + "static/img/swiss-flag.4f693924.svg";